module.exports = __webpack_public_path__ + "static/media/02_03_02_down.5fe10746.png";